// 💾 Variables
const selects = document.querySelectorAll("[data-multi-select]");

// 📐 Functions
const selectOpen = (select) => {
  select.classList.add("open");
  const menu = select.querySelector("[data-select-menu]");
  menu.classList.add("select__menu--open");
};

const selectClose = (select) => {
  select.classList.remove("open");
  const menu = select.querySelector("[data-select-menu]");
  menu.classList.remove("select__menu--open");
};

const selectToggle = (select) => {
  if (select.classList.contains("open")) {
    selectClose(select);
  } else {
    selectOpen(select);
  }
};

const parseInputValue = (value) => {
  try {
    return JSON.parse(value.replace(/'/g, '"'));
  } catch {
    return [];
  }
};

const stringifyInputValue = (arr) => {
  return JSON.stringify(arr).replace(/"/g, "'");
};

const updateLabel = (values, select) => {
  if (values.length !== 0) {
    let label = [];
    values.forEach((value) => {
      const option = select.querySelector(
        `[data-select-option="${CSS.escape(value)}"] button`,
      ).textContent;

      label.push(option);
    });

    select.querySelector("[data-select-readonly]").value = label
      .join(", ")
      .trim(" ");
  } else {
    select.querySelector("[data-select-readonly]").value = "";
  }
};

const selectUpdateValue = (select, option) => {
  const input = select.querySelector("[data-select-value]");
  const value = option.getAttribute("data-select-option");
  let values = parseInputValue(input.value);

  if (values.includes(value)) {
    const newValues = values.filter((v) => v !== value);
    input.value = JSON.stringify(newValues);
    updateLabel(newValues, select);
    select
      .querySelector(
        `[data-select-option="${CSS.escape(value)}"] [data-input-phone-option-checkmark]`,
      )
      .classList.add("hidden");
  } else {
    const newValues = [...values, value];
    input.value = JSON.stringify(newValues);
    updateLabel(newValues, select);
    select
      .querySelector(
        `[data-select-option="${CSS.escape(value)}"] [data-input-phone-option-checkmark]`,
      )
      .classList.remove("hidden");
  }

  const event = new Event("input", { bubbles: true });
  input.dispatchEvent(event);
};

const initSelect = (select) => {
  const input = select.querySelector("[data-select-value]");
  const currentValue = input.value;

  if (currentValue) {
    const selectedValues = parseInputValue(currentValue);
    updateLabel(selectedValues, select);
    selectedValues.forEach((val) => {
      const selectedOption = select.querySelector(
        `[data-select-option="${CSS.escape(val)}"]`,
      );

      if (selectedOption) {
        selectedOption
          .querySelector("[data-input-phone-option-checkmark]")
          .classList.remove("hidden");
      }
    });
  }
};

// 🖱️ Event listeners
if (selects.length !== 0) {
  Array.from(selects).forEach((select) => {
    const trigger = select.querySelector("[data-input-trigger-open]");
    const options = select.querySelectorAll("[data-select-option]");

    initSelect(select);

    trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      selectToggle(select);
    });

    Array.from(options).forEach((option) => {
      option.addEventListener("click", (e) => {
        e.preventDefault();
        selectUpdateValue(select, option);
      });
    });

    document.addEventListener("click", (e) => {
      if (!select.contains(e.target)) {
        selectClose(select);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        selectClose(select);
      }
    });
  });
}
